// extracted by mini-css-extract-plugin
export default {"EditOldWarningModal":"EditOldWarningModal_EditOldWarningModal__NHkXG","Buttons":"EditOldWarningModal_Buttons__pXi-9"};